import request from '@/request/request'

// 根据设备分类ID获取设备列表
export function getDeviceList(params) {
    return request({
        url: `/api/data2-server/collect/getDeviceListByType`,
        method: 'get',
        params
    })
}
// 查询获取设备运行状态信息
export function getDeviceStatusInfo(id) {
    return request({
        url: `/api/data2-server/collect/getDeviceStatusInfo/${id}`,
        method: 'get',
        params: {}
    })
}
// 获取物联网设备类型
export function getDeviceType() {
    return request({
        url: `/api/data2-server/collect/getDeviceType`,
        method: 'get',
        params: {}
    })
}
// 获取物联网设备类型
export function getWaterPaymentList(params) {
    return request({
        url: `/api/data2-server/water/paymentList`,
        method: 'get',
        params
    })
}